export const isEmailValid = (email: string): boolean => {
  const re = /^[a-z0-9+_-]+(\.[a-z0-9+_-]+)*@[a-z0-9+_-]+\.[a-z0-9+_-]+(\.[a-z0-9+_-]+)*$/;

  // biome-ignore lint/suspicious/noControlCharactersInRegex: Control characters are part of the ascii set
  const ascii = /^[\x00-\x7F]*$/;

  return re.test(email) && ascii.test(email);
};

export const isZipCodeFormatValid = (zipCode: string): boolean => {
  return zipCode !== undefined && /\d|[A-z]/.test(zipCode);
};

export const isCipFormatValid = (cip: string): boolean => {
  return /^\d{7}$/.test(cip);
};

export const isSirenValid = (siren: string): boolean => {
  return /\d{9}/.test(siren);
};

export const isSiretValid = (siret: string): boolean => {
  return /\d{14}/.test(siret);
};

export const isRppsValid = (rpps: string): boolean => {
  return /^\d{11}$/.test(rpps);
};

// source https://stackoverflow.com/a/17773849
export const isUrlValid = (url: string) =>
  /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/.test(
    url
  );
